import { FC, useEffect } from 'react';
import { ContentLoader, MetaData } from '@edikk-edikk/country-common';
import { Background } from '#home/components/Background';
import { Content } from '#home/components/Content';
import homeCss from '#srcCssModules/home/home.module.scss';
import { useBaseContentControl } from '#base/hooks';
import { useApi } from '#hooks/use-api';
import { HomeContext, HomeContextType } from '#home/contexts';

const Home: FC = () => {
  const { setIsContentHeightAuto } = useBaseContentControl();
  const api = useApi();
  const { data, isFetching } = api.getApiHome().useInitQuery();

  useEffect(() => {
    setIsContentHeightAuto(true);

    return () => {
      setIsContentHeightAuto(false);
    };
  }, [setIsContentHeightAuto]);

  if (isFetching) {
    return <ContentLoader />;
  }

  const homeContextValue: HomeContextType = {
    seo: data.seo,
    popularCityList: data.popularCityList,
    mainImageUrl: data.mainImageUrl,
  };

  return (
    <HomeContext value={homeContextValue}>
      <div className={homeCss.home}>
        <MetaData seo={data.seo} />
        <Background />
        <Content />
      </div>
    </HomeContext>
  );
};

export default Home;
